import { Frame } from '@shopify/polaris';
import { NavMenu, TitleBar } from '@shopify/app-bridge-react';
import { Link } from 'react-router-dom';
import { ToastProvider } from '../context/ToastContext';

interface AppFrameProps {
  children: React.ReactNode;
  shop: string | null;
}

/**
 * Embedded app shell.
 *
 * Navigation uses App Bridge <NavMenu> so the menu renders in the Shopify admin
 * sidebar (the standard embedded-app pattern) rather than a custom Polaris
 * <Navigation> inside the iframe. App Bridge reads the child <Link> hrefs and
 * drives in-app routing (React Router handles the actual navigation, no reload).
 * The first link uses rel="home" to designate the app home; Shopify hides it
 * from the rendered list.
 *
 * <TitleBar> sets the app title in the admin chrome. Per-page Polaris <Page>
 * headings still render inside the iframe.
 *
 * The Polaris <Frame> is retained purely to host the toast overlay
 * (see ToastProvider), not for navigation.
 */
export function AppFrame({ children, shop: _shop }: AppFrameProps) {
  return (
    <>
      <NavMenu>
        <Link to="/" rel="home">
          Dashboard
        </Link>
        <Link to="/products">Products</Link>
        <Link to="/links">Affiliate Links</Link>
        <Link to="/analytics">Analytics</Link>
        <Link to="/calls">Call Tracking</Link>
        <Link to="/ally">Ally AI</Link>
        <Link to="/settings">Settings</Link>
        <Link to="/billing">Billing</Link>
      </NavMenu>
      <TitleBar title="Affilync" />
      <Frame>
        <ToastProvider>{children}</ToastProvider>
      </Frame>
    </>
  );
}
